import { Flex, Text } from "@chakra-ui/react";

const CardInfoItem = ({ children, title }) => {
  return (
    <Flex
      direction={"column"}
      rowGap={"4px"}
      fontSize={"14px"}
      fontWeight={"400"}
      lineHeight={"1"}
      letterSpacing={"2%"}
    >
      <Text
        fontSize={"12px"}
        lineHeight={"1.35"}
        letterSpacing={"4%"}
        color={"grey"}
      >
        {title}
      </Text>
      {children}
    </Flex>
  );
};

export default CardInfoItem;
